/**
 * This generates valid aria properties in the DOM. It helps to have a basic function to easily refactor and search throughout your codebase.
 *
 * ```js
 * import { aria } from '@polestar/component-warehouse-react';
 *
 * <div {...aria({label: 'A custom label describing the content'})}>custom component</div>
 * ```
 *
 * @storybook Helpers/aria
 */
const aria = (values) => {
    const result = {};
    for (const key in values) {
        const value = values[key];
        switch (key) {
            case 'role':
                result.role = value;
                break;
            case 'disabled':
                if (value === true) {
                    result[`aria-${key}`] = true;
                }
                break;
            case 'label':
                if (value !== undefined && value !== '') {
                    result[`aria-${key}`] = value;
                }
                break;
            case 'current':
            case 'errormessage':
            case 'describedby':
                if (value !== undefined && value !== false) {
                    result[`aria-${key}`] = value;
                }
                break;
            default:
                result[`aria-${key}`] = value;
        }
    }
    return result;
};
export default aria;
